import React, { useState } from 'react';
import { useSelector, shallowEqual } from 'react-redux';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import { getPagesList } from '#component/user/pages';
import SideList from '#component/drawer/side-list';
import { StyledDrawer } from './styles';

const MobileAppDrawer = ({ account, socket }) => {
  const projects = useSelector(s => s.account.directProjects, shallowEqual);
  const [expanded, setExpanded] = useState(false);

  const toggleDrawer = () => {
    setExpanded(prevState => !prevState);
  };

  const handleDrawerClose = () => {
    setExpanded(false);
  };

  const rootProject = projects?.find(p => p.level === 0);
  const pagesList = getPagesList(account.userType, account.id, rootProject);

  return (
    <div>
      <IconButton
        color="inherit"
        aria-label="Menu"
        onClick={toggleDrawer}
      >
        <MenuIcon style={{ color: '#FFF' }} />
      </IconButton>
      <StyledDrawer
        open={expanded}
        variant="temporary"
        onClose={handleDrawerClose}
      >
        <div
          onClick={handleDrawerClose}
          onKeyDown={handleDrawerClose}
          tabIndex={0}
          role="button"
          aria-label="Menu"
        >
          <SideList
            socket={socket}
            expanded={expanded}
            toggleDrawer={toggleDrawer}
            pagesList={pagesList}
            drawerHeader={true}
            isMobile={true}
          />
        </div>
      </StyledDrawer>
    </div>
  );
};

export default MobileAppDrawer;
